"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const urlParser_1 = require("../utils/urlParser");
////// t-im 과 im 조심할것 (사이드이펙트)
const uriSelector = () => {
    if ((0, urlParser_1.isIncludesOneof)(["dev-", "st-", "to-", "localhost"])) {
        return "https://dev-im.diningcode.com/API";
    }
    if (!window.location.href.includes("html") &&
        (0, urlParser_1.isIncludesOneof)(["twww.", "tm."])) {
        return "http://tim.diningcode.com/API";
    }
    return "https://im.diningcode.com/API";
};
exports.default = uriSelector;
